export const ADD_FILTER = "ADD_FILTER";
export const CLEAR_FILTERS = "CLEAR_FILTERS";
export const REMOVE_FILTER = "REMOVE_FILTER";

export const FILL_JOB_LIST = "FILL_JOB_LIST";